<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        Rescinding Reason
    </div>
    <div class="nova__dialog__toolbar__controls">
        <button class="nova__button--icon" (click)="close()">
            <mat-icon class="nova-toolbar__controls__icon--close">
                close
            </mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-content class="nova__dialog__content">
    <div class="option-title">
        <strong>
            Select a reason for rescinding this offer:
        </strong>
    </div>
    <div>
        <mat-form-field>
            <mat-select [(ngModel)]="reasonResult">
                @for (reason of data.reasons; track reason) {
                <mat-option [value]="reason">{{reason.name}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    @if(isOtherReason()) {
    <div>
        <mat-form-field>
            <input matInput [(ngModel)]="reasonDesc">
        </mat-form-field>
    </div>
    }
    <mat-dialog-actions class="nova__dialog__content__actions" align="start">
        <button [disabled]="(isOtherReason() && !reasonDesc) || !reasonResult" (click)="confirm()" mat-raised-button
            color="primary" [mat-dialog-close]="true">
            RESCIND OFFER
        </button>
        <button class="cancel-button" mat-button (click)="close()">
            CANCEL
        </button>
    </mat-dialog-actions>
</div>